import React from 'react';


function Cross() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.64">
        <path fillRule="evenodd" clipRule="evenodd" d="M10.0002 16.6667C13.6821 16.6667 16.6668 13.6819 16.6668 10C16.6668 6.31814 13.6821 3.33337 10.0002 3.33337C6.31826 3.33337 3.3335 6.31814 3.3335 10C3.3335 13.6819 6.31826 16.6667 10.0002 16.6667ZM8.33732 7.22947L8.26353 7.16431L8.18403 7.11001C7.88333 6.93082 7.48842 6.97064 7.22958 7.22947C6.92369 7.53537 6.92369 8.03132 7.22958 8.33721L8.89181 9.99996L7.22958 11.6629L7.16442 11.7367C6.9255 12.044 6.94722 12.4883 7.22958 12.7706C7.53548 13.0765 8.03143 13.0765 8.33732 12.7706L10.0002 11.1083L11.663 12.7706L11.7368 12.8358C12.0441 13.0747 12.4884 13.053 12.7707 12.7706C13.0766 12.4647 13.0766 11.9688 12.7707 11.6629L11.1077 9.99996L12.7707 8.33721L12.8359 8.26342C13.0748 7.95614 13.0531 7.51184 12.7707 7.22947C12.4648 6.92358 11.9689 6.92358 11.663 7.22947L10.0002 8.89239L8.33732 7.22947Z" fill="#001325"/>
      </g>
    </svg>

  );
}

export default Cross;
